import ModuleBootstrapper from '../common/ModuleBootstrapper/ModuleBootstrapper';

import SalesReport from './containers/SalesReport';
import LegacyReports from './containers/LegacyReports';

const routes = [
    {
        type: 'simple',
        name: 'new-reports',
        view: SalesReport,
        path: '/reports/new-reports'
    },
    {
        type: 'simple',
        name: 'legacy-reports',
        view: LegacyReports,
        path: '/reports/legacy-reports'
    }
]

export default ModuleBootstrapper.getRoutes("reports", routes)
